import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormLabel,
  Grid,
  FormHelperText
} from '@material-ui/core';
import {
    CONFIG_FIELD_INPUT_BASE,
    CONFIG_FIELD_SELECT,
    CONFIG_FIELD_RADIO,
    CONFIG_FIELD_CHECKBOX,
    CONFIG_FIELD_BUTTON,
    CONFIG_FIELD_FILE,
    CONFIG_FIELD_ROW,
    CONFIG_FIELD_TEXT,
    CONFIG_FIELD_TYPOGRAPHY,
    CONFIG_FIELD_SELECT_WITH_TYPING,
    CONFIG_FIELD_PHONE_NUMBER,
    CONFIG_FIELD_TEXTAREA_LIMIT,
    CONFIG_FIELD_DATE
  } from './formConfigs';
import { makeStyles } from '@material-ui/core/styles';
import DatePickerTDSAT from './components/DatePickerTDSAT';

const useStyles = makeStyles(() => ({
  asteriskRed: {
    '& .MuiFormLabel-asterisk': {
      color: 'red',
    },
  },
}));

const FormField = ({ field, value, onChange, onClick, disabled=false, error }) => {
  const classes = useStyles();
  const handleChange = (event) => {
    onChange(field.keyId, event.target.value);
  };

  const lastKeyRef = React.useRef('');
  const keyPressCountRef = React.useRef(0);
  const lastKeyTimeRef = React.useRef(0);

  const handleKeyNavigation = (event) => {
    const char = event.key.toLowerCase();
    const now = Date.now();

    if (char.length === 1 && /[a-z]/.test(char)) {
      if (char === lastKeyRef.current && now - lastKeyTimeRef.current < 1000) {
        keyPressCountRef.current++;
      } else {
        lastKeyRef.current = char;
        keyPressCountRef.current = 0;
      }
      lastKeyTimeRef.current = now;

      const matches = field.options.filter(opt =>
        opt.toLowerCase().startsWith(char)
      );

      if (matches.length > 0) {
        const index = keyPressCountRef.current % matches.length;
        const selected = matches[index];
        onChange(field.keyId, selected);
      }

      event.preventDefault();
    }
  };

    switch (field.type) {
      case CONFIG_FIELD_INPUT_BASE:
        return (
          <TextField
            label={field.label}
            fullWidth
            required={field.required}
            multiline={field.multiline || false}
            rows={field.rows || 1}
            margin="none"
            variant="outlined"
            value={value}
            onChange={handleChange}
            error={error}
            helperText={error ? error : ""}
            disabled={disabled}
            placeholder={field?.placeholder || ''}
            className={classes.asteriskRed}
          />
        );
      case CONFIG_FIELD_PHONE_NUMBER:
        const handlePhoneChange = (event) => {
          let input = event.target.value;

          // Allow only digits and limit to 10
          input = input.replace(/[^0-9]/g, '').slice(0, 10);

          onChange(field.keyId, input);
        };

        return (
          <TextField
            label={field.label}
            fullWidth
            required={field.required}
            margin="none"
            variant="outlined"
            value={value}
            onChange={handlePhoneChange}
            error={error}
            helperText={error ? error : ""}
            disabled={disabled}
            placeholder={field?.placeholder || ''}
            inputProps={{ maxLength: 10 }}
          />
        );
      case CONFIG_FIELD_SELECT:
        return (
          <FormControl required={field.required} fullWidth margin="none" variant='outlined' error={error}>
            <InputLabel id={field?.label} className={classes?.asteriskRed} >{field.label}</InputLabel>
            <Select labelId={field?.label} label={field.label} onChange={handleChange} value={value} disabled={disabled}>
              {field.options.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            {error && (
              <FormHelperText>{error}</FormHelperText>
            )}
          </FormControl>
        );
      case CONFIG_FIELD_RADIO:
        return (
          <FormControl component="fieldset" margin="normal" required={field.required} error={error}>
            <FormLabel component="legend">{field.label}</FormLabel>
            <RadioGroup row onChange={handleChange} value={value}>
              {field.options.map((option, index) => (
                <FormControlLabel key={index} value={option} control={<Radio />} label={option} />
              ))}
            </RadioGroup>
            {error && (
              <FormHelperText>{error}</FormHelperText>
            )}
          </FormControl>
        );
      case CONFIG_FIELD_CHECKBOX:
        return (
          <FormControl component="fieldset" margin="normal">
            <FormLabel component="legend">{field.label}</FormLabel>
            {/* {field.subTitle && <Typography>{field.subTitle}</Typography>} */}
            {field.options.map((option, index) => (
              <FormControlLabel key={index} control={<Checkbox />} label={option} />
            ))}
          </FormControl>
        );
      case CONFIG_FIELD_BUTTON:
        return (
          <Button onClick={onClick} variant="contained" startIcon={field.startIcon} endIcon={field.icon} color="primary" fullWidth sx={{ my: 2 }} style={{background: field.backgroundColor, color: field.color}} disabled={disabled}>
            {field.label}
          </Button>
        );
      case CONFIG_FIELD_FILE:
        return (
          <Box margin="normal">
            <Button startIcon={field.startIcon} variant="contained" component="label" style={{background: "#4A3BFF", color: '#ffffff', display: 'flex', justifyContent: 'flex-start'}}>
              {field.label}
              <input type="file" hidden />
            </Button>
            <Typography variant="caption" display="flex">{field.subtitle}</Typography>
          </Box>
        );
      case CONFIG_FIELD_ROW:
      return (
        <Grid container spacing={2} style={{borderBottom: '1px solid #858D98', paddingBottom: '30px', marginBottom: '22px'}}>
          <Grid item xs={12}>
            <Typography style={{fontWeight: 'bold', textAlign: 'left'}}>Please enter details of the connected matter (if any).</Typography>
          </Grid>
          {field.fields.map((subField, index) => (
            <Grid item xs={6} key={index}>
              <FormField field={subField}  value={value[subField.keyId]} onChange={onChange} error={error[subField.keyId]}/>
            </Grid>
          ))}
        </Grid>
      );
      case CONFIG_FIELD_TEXT:
        return (
          <Grid container spacing={2}>
            <Typography style={{marginRight:'60px'}}>{field.label}</Typography>
            <Typography>{field.value}</Typography>
          </Grid>
        );
      case CONFIG_FIELD_TYPOGRAPHY:
        return (
          <Grid container spacing={2} style={{marginBottom:"10px"}}>
            <Typography style={{fontWeight: 'bold'}}>{field?.label || 'Impugned Order Details:'} </Typography>
          </Grid>
        );
      case CONFIG_FIELD_SELECT_WITH_TYPING:
        return (
        <Box
          onKeyDown={handleKeyNavigation}
          tabIndex={0} // make focusable
          style={{width: '100%'}}
        >
          <FormControl
            required={field.required}
            fullWidth
            margin="none"
            variant="outlined"
            error={error}
          >
            <InputLabel>{field.label}</InputLabel>
            <Select
              label={field.label}
              onChange={(e) => onChange(field.keyId, e.target.value)}
              value={value}
              disabled={disabled}
            >
              {field.options.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
        </Box>
        );
      case CONFIG_FIELD_TEXTAREA_LIMIT: {
        const maxChars = field.maxChars || 300;

        const handleTextAreaChange = (event) => {
          let input = event.target.value;

          if (input.length > maxChars) {
            input = input.slice(0, maxChars);
          }

          onChange(field.keyId, input);
        };

        const remainingChars = maxChars - (value ? value.length : 0);

        return (
          <Box style={{width: '100%'}}>
            <TextField
              label={field.label}
              fullWidth
              multiline
              rows={field.rows || 6} // bigger textarea
              margin="none"
              variant="outlined"
              value={value}
              onChange={handleTextAreaChange}
              error={error}
              helperText={error ? error : `${remainingChars} characters remaining`}
              disabled={disabled}
              placeholder={field?.placeholder || ''}
              inputProps={{ maxLength: maxChars }}
              FormHelperTextProps={{
                style: { textAlign: 'right', width: '100%', marginLeft: 0 }
              }}
            />
          </Box>
        );
      }

      case CONFIG_FIELD_DATE: 
        return (
          <FormControl fullWidth margin="none" variant="outlined">
            <DatePickerTDSAT
              date={value}
              setDate={onChange}
              isRequired={field?.required}
              label={field?.label}
              size={field?.size}
              minimumDate={field?.minimumDate}
              maximumDate={field?.maximumDate}
              error={error}
            />
            {error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
        )


      default:
        return null;
    }
  };


export default FormField;